import React from "react";
import type { Illustration } from "../util";
import { illustrationProps } from "../util";

export const PaymentMarkedAsHandled: Illustration = (props) => (
  <svg viewBox="0 0 138 92" {...illustrationProps(props, { width: 138 })}>
    <path
      d="M33.593 3.407c-1.67 5.136-3.333 10.27-5.004 15.405l-.72 2.213c-.425 1.314 1.61 1.912 2.037.593 1.67-5.136 3.334-10.27 5.005-15.406L35.63 4c.425-1.314-1.61-1.912-2.038-.593Z"
      fill="#E4E1DD"
    />
    <path
      d="M23.434 11.013c5.055 1.512 10.105 3.021 15.16 4.534.707.21 1.414.42 2.118.636 1.307.388 1.944-1.66.634-2.057-5.055-1.512-10.105-3.021-15.16-4.534-.707-.21-1.414-.42-2.117-.635-1.308-.389-1.944 1.66-.635 2.056Z"
      fill="#E4E1DD"
    />
    <path
      d="m39.5 6.785-14.329 7.58c-.684.366-1.37.724-2.055 1.09-1.226.651-.258 2.534.967 1.883 4.78-2.528 9.55-5.053 14.33-7.58.684-.367 1.37-.724 2.055-1.09 1.226-.652.258-2.535-.967-1.883Z"
      fill="#E4E1DD"
    />
    <path
      d="M27.084 5.066c2.435 4.674 4.86 9.35 7.295 14.024l1.018 1.962c.627 1.21 2.526.2 1.9-1.01-2.427-4.677-4.861-9.35-7.288-14.027l-1.017-1.962c-.627-1.21-2.527-.2-1.9 1.01l-.008.003Z"
      fill="#E4E1DD"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M117.064 88.186c2.879 0 5.213-2.315 5.213-5.171 0-2.856-2.334-5.172-5.213-5.172s-5.213 2.316-5.213 5.172 2.334 5.171 5.213 5.171Zm0 2.434c4.234 0 7.666-3.405 7.666-7.605 0-4.2-3.432-7.605-7.666-7.605s-7.666 3.405-7.666 7.605c0 4.2 3.432 7.605 7.666 7.605Z"
      fill="#B6B1AC"
    />
    <path
      d="M124.813 36.067a69.527 69.527 0 0 1-1.365-3.201c-.282-.727.026-1.495.734-1.833.668-.319 1.58.047 1.848.728a69.115 69.115 0 0 0 1.348 3.163 72.01 72.01 0 0 1 3.376-1.42 1.443 1.443 0 0 1 1.848.729c.321.662-.048 1.566-.735 1.833a71.195 71.195 0 0 0-3.337 1.403 71.178 71.178 0 0 0 1.573 3.287c.355.692-.087 1.525-.735 1.833-.715.344-1.511-.083-1.847-.728a67.01 67.01 0 0 1-1.557-3.25 70.825 70.825 0 0 0-3.165 1.494c-.697.353-1.536-.085-1.847-.728-.347-.71.083-1.5.734-1.833a66.42 66.42 0 0 1 3.127-1.477ZM25.896 73.329a3.142 3.142 0 0 0-1.47-2.113c-.759-.442-1.806-.504-2.675-.407-.565.062-1.055.193-1.509.517-.349.249-.594.594-.75.974-.416.152-.669.504-.713.953-.082.8.26 1.609.824 2.216.216.36.506.656.922.843.445.2.914.324 1.396.393 1.026.145 2.244.207 3.076-.476.327-.27.49-.615.543-.988.059-.083.111-.165.156-.248.267-.539.304-1.084.2-1.664Zm-3.93.228s.015-.014 0 0Z"
      fill="#D3CEC9"
    />
    <rect
      x="54.236"
      y="14"
      width="53.072"
      height="53.072"
      rx="10"
      transform="rotate(15 54.236 14)"
      fill="#D3CEC9"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M96.68 37.874a3.191 3.191 0 0 1-1.153 4.43L64.173 60.313c-.765.44-1.68.556-2.54.323a3.332 3.332 0 0 1-2.025-1.56l-5.97-10.482a3.192 3.192 0 0 1 1.263-4.402c1.59-.863 3.602-.291 4.495 1.277l4.314 7.573 28.444-16.337a3.354 3.354 0 0 1 4.526 1.17Z"
      fill="#938E8A"
    />
  </svg>
);
